export default {
    setPortfolio(state, portfolio) {
        state.portfolio = portfolio;
    },
    setSelectedPortfolio(state, portfolio) {
        state.selectedPortfolio = portfolio;
    },
    updatePortfolioTemplateSettings(state, payload) {
        this.deepMerge(state.portfolio.templateSettings, payload);
    },
    updatePortfolioDescription(state, payload) {
        state.portfolio.description = payload;
    },
    updatePortfolioHero(state, payload) {
        this.deepMerge(state.portfolio.templateSettings.hero, payload);
    },
    updatePortfolioHeroSection(state, payload) {
        this.deepMerge(state.portfolio.portfolioHero, payload);
    },
    setPortfolioTemplateSocialIconStyle(state, payload) {
        state.portfolio.templateSettings.socialIconStyle = payload
    },
    preservePortfolioHeroContent(state, payload) {
        if (!state.portfolio?.portfolioHero) return;

        const clone = (value) => JSON.parse(JSON.stringify(value));

        if (Object.prototype.hasOwnProperty.call(payload || {}, "text")) {
            state.portfolio.portfolioHero.text = clone(payload.text);
        }

        if (Object.prototype.hasOwnProperty.call(payload || {}, "socialIcons")) {
            state.portfolio.portfolioHero.socialIcons = clone(payload.socialIcons);
        }

        if (Object.prototype.hasOwnProperty.call(payload || {}, "cta")) {
            state.portfolio.portfolioHero.cta = clone(payload.cta);
        }
    },
    setPortfolioHeroSocialIcons(state, payload) {
        state.portfolio.portfolioHero.socialIcons = payload.socialIcons;
    },
    updatePortfolioHeroAssetByKey(state, { key, payload }) {
        if (!state.portfolio?.portfolioHero) {
            return;
        }
        state.portfolio.portfolioHero[key] = payload;
    },
    updatePortfolioHeroLayoutSettings(state, payload) {
        if (state.portfolio?.portfolioHero) {
            state.portfolio.portfolioHero.layoutSettings = payload;
        }
    },
    updatePortfolioNavigation(state, payload) {
        if (!state.portfolio?.portfolioNavigation) {
            return;
        }
        this.deepMerge(state.portfolio.portfolioNavigation, payload);
    },
    updatePortfolioLogo(state, payload) {
        if (!state.portfolio?.logo) {
            state.portfolio.logo = payload;
            return;
        }
        this.deepMerge(state.portfolio.logo, payload);
    },
    updatePortfolioDesignSettings(state, payload) {
        this.deepMerge(state.portfolio.designSettings, payload);
    },
    setPortfolioFooterData(state, payload) {
        state.portfolio.portfolioFooter[payload.key] = payload.value
    },
    updatePortfolioFooter(state, payload) {
        state.portfolio.portfolioFooter = payload;
    },
    setRelatedCaseStudyFooterData(state, payload) {
        state.portfolio.relatedCaseStudyFooter[payload.key] = payload.value;
    },
    updatePortfolioShortId(state, shortId) {
        if (state.portfolio) {
            state.portfolio.shortId = shortId;
        }
        (state.project ? [state.project] : []).forEach(project => project.portfolioShortId = shortId);
        (state.caseStudyPages || []).forEach(page => page.portfolioShortId = shortId);
        (state.portfolioPages || []).forEach(page => page.portfolioShortId = shortId);
    }
}